<div class="page-not-found-component d-flex justify-content-center align-items-center">
    <div class="parent-container d-flex justify-content-center align-items-center">
        <div class="icon-container">
        </div>
        <div class="text-container">
            <div>
                <p style="font-size: 80px; font-weight: bold">404</p>
                <p style="font-size: 20px; font-weight: bold">Oops! Page Not Found</p>
                <p>The page you're looking for doesn't exist. It might have been removed, renamed, or is temporarily
                    unavailable.</p>
            </div>
            <div>
                <button class="homepage-button" (click)="onHomePageBtnClick()"> <- Back to Homepage</button>
            </div>
        </div>
    </div>
</div>